import React, { useState, useEffect, useRef } from "react";

// ─── Inject global styles once ────────────────────────────────────────────────
const STYLE_ID = "issue-sidebar-styles";
if (!document.getElementById(STYLE_ID)) {
  const s = document.createElement("style");
  s.id = STYLE_ID;
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Mono:wght@400;500&display=swap');

    .iss-overlay {
      position: fixed; inset: 0;
      background: rgba(4, 8, 20, 0.52);
      backdrop-filter: blur(3px);
      -webkit-backdrop-filter: blur(3px);
      z-index: 1998;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.26s ease;
    }
    .iss-overlay.visible { opacity: 1; pointer-events: all; }

    .iss-panel {
      position: fixed;
      top: 0; right: 0; bottom: 0;
      width: 376px;
      background: #070d1a;
      border-left: 1px solid rgba(255,255,255,0.055);
      z-index: 1999;
      display: flex; flex-direction: column;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.26s ease;
      font-family: 'Syne', sans-serif;
      box-shadow: -24px 0 64px rgba(0,0,0,0.65);
    }
    .iss-panel.visible { opacity: 1; pointer-events: all; }

    /* Context menu */
    .iss-ctx-menu {
      position: fixed;
      background: #0d1425;
      border: 1px solid rgba(255,255,255,0.09);
      border-radius: 10px;
      padding: 6px;
      z-index: 2100;
      min-width: 210px;
      box-shadow: 0 16px 48px rgba(0,0,0,0.65), 0 0 0 1px rgba(255,255,255,0.04);
      opacity: 0;
      transform: scale(0.94);
      pointer-events: none;
      transition: opacity 0.18s ease, transform 0.18s ease;
      font-family: 'Syne', sans-serif;
    }
    .iss-ctx-menu.visible {
      opacity: 1;
      transform: scale(1);
      pointer-events: all;
    }
    .iss-ctx-header {
      padding: 6px 10px 8px;
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 1.1px;
      text-transform: uppercase;
      color: rgba(255,255,255,0.22);
      font-family: 'DM Mono', monospace;
      border-bottom: 1px solid rgba(255,255,255,0.05);
      margin-bottom: 4px;
    }
    .iss-ctx-item {
      display: flex; align-items: center; gap: 10px;
      padding: 9px 10px;
      border-radius: 7px;
      cursor: pointer;
      transition: background 0.14s;
      font-size: 13px;
      font-weight: 600;
      color: rgba(255,255,255,0.75);
      user-select: none;
    }
    .iss-ctx-item:hover { background: rgba(255,255,255,0.06); color: #e8eaf0; }
    .iss-ctx-item-icon {
      width: 28px; height: 28px;
      border-radius: 7px;
      display: flex; align-items: center; justify-content: center;
      font-size: 14px;
      flex-shrink: 0;
    }
    .iss-ctx-divider {
      height: 1px;
      background: rgba(255,255,255,0.05);
      margin: 4px 0;
    }

    /* Scrollbar */
    .iss-scroll::-webkit-scrollbar { width: 3px; }
    .iss-scroll::-webkit-scrollbar-track { background: transparent; }
    .iss-scroll::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.07); border-radius: 3px; }

    /* Inputs */
    .iss-input {
      width: 100%; padding: 9px 12px;
      background: rgba(255,255,255,0.038);
      border: 1px solid rgba(255,255,255,0.07);
      border-radius: 8px;
      color: #dde2ee;
      font-size: 13px;
      font-family: 'DM Mono', monospace;
      outline: none;
      box-sizing: border-box;
      transition: border-color 0.2s, background 0.2s;
    }
    .iss-input:focus {
      border-color: rgba(96,165,250,0.45);
      background: rgba(96,165,250,0.04);
    }
    .iss-input::placeholder { color: rgba(255,255,255,0.18); }

    /* Select */
    .iss-sel-box { position: relative; }
    .iss-sel-trigger {
      display: flex; align-items: center; justify-content: space-between;
      padding: 9px 12px;
      background: rgba(255,255,255,0.038);
      border: 1px solid rgba(255,255,255,0.07);
      border-radius: 8px;
      cursor: pointer;
      font-size: 13px;
      font-family: 'DM Mono', monospace;
      color: #dde2ee;
      user-select: none;
      transition: border-color 0.2s, background 0.2s;
    }
    .iss-sel-trigger:hover, .iss-sel-trigger.open {
      border-color: rgba(96,165,250,0.45);
      background: rgba(96,165,250,0.04);
    }
    .iss-sel-arrow { font-size: 9px; color: rgba(255,255,255,0.28); transition: transform 0.2s; }
    .iss-sel-arrow.open { transform: rotate(180deg); }
    .iss-sel-dropdown {
      position: absolute; top: calc(100% + 4px); left: 0; right: 0;
      background: #0f1828;
      border: 1px solid rgba(96,165,250,0.22);
      border-radius: 8px; overflow: hidden;
      z-index: 9999; max-height: 210px; overflow-y: auto;
      box-shadow: 0 14px 40px rgba(0,0,0,0.55);
    }
    .iss-sel-opt {
      display: flex; align-items: center; gap: 9px;
      padding: 9px 12px;
      font-size: 12px; font-family: 'DM Mono', monospace;
      color: rgba(255,255,255,0.6);
      cursor: pointer;
      border-bottom: 1px solid rgba(255,255,255,0.03);
      transition: background 0.13s, color 0.13s;
    }
    .iss-sel-opt:last-child { border-bottom: none; }
    .iss-sel-opt:hover { background: rgba(96,165,250,0.08); color: #dde2ee; }
    .iss-sel-opt.active { background: rgba(96,165,250,0.11); color: #60a5fa; }

    /* Labels / fields */
    .iss-lbl {
      display: block; margin-bottom: 5px;
      font-size: 10px; font-weight: 700;
      letter-spacing: 1.1px; text-transform: uppercase;
      color: rgba(255,255,255,0.26);
    }
    .iss-field { margin-bottom: 13px; }
    .iss-divider { height: 1px; background: rgba(255,255,255,0.05); margin: 14px 0; }

    /* Buttons */
    .iss-btn-primary {
      flex: 1; padding: 11px 16px;
      background: linear-gradient(135deg, #2563eb, #1d4ed8);
      border: none; border-radius: 9px;
      color: #fff; font-family: 'Syne', sans-serif;
      font-size: 13px; font-weight: 700; letter-spacing: 0.3px;
      cursor: pointer;
      transition: opacity 0.18s, transform 0.14s;
    }
    .iss-btn-primary:hover { opacity: 0.86; transform: translateY(-1px); }
    .iss-btn-primary:active { transform: translateY(0); }

    .iss-btn-ghost {
      padding: 11px 15px;
      background: rgba(255,255,255,0.04);
      border: 1px solid rgba(255,255,255,0.08);
      border-radius: 9px;
      color: rgba(255,255,255,0.32);
      font-family: 'Syne', sans-serif;
      font-size: 13px; font-weight: 600;
      cursor: pointer;
      transition: all 0.18s;
    }
    .iss-btn-ghost:hover { border-color: rgba(255,255,255,0.18); color: rgba(255,255,255,0.65); }

    .iss-type-badge {
      display: inline-flex; align-items: center; gap: 7px;
      padding: 5px 11px; border-radius: 20px;
      font-size: 11px; font-weight: 700;
      letter-spacing: 0.5px; text-transform: uppercase;
      font-family: 'DM Mono', monospace;
    }
    .iss-hint {
      font-size: 11px; color: rgba(255,255,255,0.2);
      font-family: 'DM Mono', monospace;
      margin: 7px 0 0; line-height: 1.55;
    }
  `;
  document.head.appendChild(s);
}

// ─── Data ─────────────────────────────────────────────────────────────────────
const ISSUE_CATEGORIES = [
  { value: "commissioning", label: "Commissioning" },
  { value: "coordination", label: "Coordination" },
  { value: "design", label: "Design" },
  { value: "general", label: "General" },
  { value: "observation", label: "Observation" },
  { value: "punch_list", label: "Punch List" },
  { value: "quality", label: "Quality" },
  { value: "safety", label: "Safety" },
  { value: "warranty", label: "Warranty" },
  { value: "work_list", label: "Work List" },
];

const TYPES_BY_CAT = {
  commissioning: [{ value: "commissioning", label: "Commissioning" }],
  coordination: [
    { value: "clash", label: "Clash" },
    { value: "coordination", label: "Coordination" },
  ],
  design: [
    { value: "building_code", label: "Building Code" },
    { value: "client_feedback", label: "Client Feedback" },
    { value: "design", label: "Design" },
    { value: "existing_condition", label: "Existing Condition" },
    { value: "requirement_change", label: "Requirement Change" },
    { value: "work_to_complete", label: "Work to Complete" },
  ],
  general: [{ value: "general", label: "General" }],
  observation: [
    { value: "observation", label: "Observation" },
    { value: "quality", label: "Quality" },
    { value: "safety", label: "Safety" },
  ],
  punch_list: [
    { value: "pre_punch_list", label: "Pre-Punch List" },
    { value: "punch_list", label: "Punch List" },
  ],
  quality: [{ value: "quality", label: "Quality" }],
  safety: [
    { value: "safety", label: "Safety" },
    { value: "safety_infraction", label: "Safety Infraction" },
  ],
  warranty: [{ value: "warranty", label: "Warranty" }],
  work_list: [
    { value: "work_list", label: "Work List" },
    { value: "work_to_complete", label: "Work to Complete" },
  ],
};

const STATUSES = [
  { value: "draft", label: "Draft", color: "#9E9E9E" },
  { value: "open", label: "Open", color: "#FF9800" },
  { value: "pending", label: "Pending", color: "#03A9F4" },
  { value: "in_progress", label: "In Progress", color: "#8BC34A" },
  { value: "completed", label: "Completed", color: "#4CAF50" },
  { value: "in_review", label: "In Review", color: "#9C27B0" },
  { value: "not_approved", label: "Not Approved", color: "#F44336" },
  { value: "in_dispute", label: "In Dispute", color: "#E91E63" },
];

const ROOT_CAUSES = [
  { value: "", label: "— none —" },
  { value: "design_error", label: "Design Error" },
  { value: "coordination_error", label: "Coordination Error" },
  { value: "equipment_failure", label: "Equipment Failure" },
  { value: "human_error", label: "Human Error" },
  { value: "material_defect", label: "Material Defect" },
  { value: "method_statement", label: "Method Statement" },
  { value: "site_conditions", label: "Site Conditions" },
  { value: "subcontractor", label: "Subcontractor" },
  { value: "weather", label: "Weather" },
  { value: "other", label: "Other" },
];

// ─── CustomSelect ─────────────────────────────────────────────────────────────
const CustomSelect = ({ options, value, onChange, withColor = false }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = options.find((o) => o.value === value) || options[0];

  useEffect(() => {
    const h = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div ref={ref} className="iss-sel-box">
      <div
        className={`iss-sel-trigger${open ? " open" : ""}`}
        onClick={() => setOpen((v) => !v)}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {withColor && selected?.color && (
            <div
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: selected.color,
                flexShrink: 0,
              }}
            />
          )}
          <span>{selected?.label || "Select…"}</span>
        </div>
        <span className={`iss-sel-arrow${open ? " open" : ""}`}>▼</span>
      </div>
      {open && (
        <div className="iss-sel-dropdown iss-scroll">
          {options.map((opt) => (
            <div
              key={opt.value}
              className={`iss-sel-opt${opt.value === value ? " active" : ""}`}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
            >
              {withColor && opt.color && (
                <div
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: opt.color,
                    flexShrink: 0,
                  }}
                />
              )}
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ─── CreateIssueForm ──────────────────────────────────────────────────────────
const CreateIssueForm = ({ issueTypeConfig, onSubmit, onClose }) => {
  const [form, setForm] = useState({
    label: issueTypeConfig?.defaultLabel || "New Issue",
    description: "",
    status: "open",
    category: "quality",
    issueType: "quality",
    assignedTo: "",
    watchers: "",
    location: "",
    locationDetails: "",
    startDate: "",
    dueDate: "",
    rootCause: "",
  });

  const types = TYPES_BY_CAT[form.category] || TYPES_BY_CAT.general;
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  const setE = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleCategoryChange = (val) => {
    const t = TYPES_BY_CAT[val] || [];
    setForm((f) => ({ ...f, category: val, issueType: t[0]?.value || "" }));
  };

  const handleSubmit = () => {
    if (!form.label.trim()) {
      alert("Title cannot be empty.");
      return;
    }
    onSubmit(form);
  };

  const accent = issueTypeConfig?.color || "#2563eb";

  return (
    <div style={{ padding: "0 20px 28px" }}>
      {/* Badge */}
      <div style={{ marginBottom: 18 }}>
        <div
          className="iss-type-badge"
          style={{
            background: `${accent}18`,
            border: `1px solid ${accent}35`,
            color: accent,
          }}
        >
          <span>{issueTypeConfig?.icon || "📍"}</span>
          <span>{issueTypeConfig?.title || "New Issue"}</span>
        </div>
        <p className="iss-hint">
          Fill the form, then click on the 3D model to place the pin.
        </p>
      </div>

      {/* Title */}
      <div className="iss-field">
        <label className="iss-lbl">
          Title <span style={{ color: accent }}>*</span>
        </label>
        <input
          className="iss-input"
          value={form.label}
          onChange={setE("label")}
          placeholder="Enter issue title"
        />
      </div>

      {/* Category + Type */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 11,
          marginBottom: 13,
        }}
      >
        <div>
          <label className="iss-lbl">
            Category <span style={{ color: accent }}>*</span>
          </label>
          <CustomSelect
            options={ISSUE_CATEGORIES}
            value={form.category}
            onChange={handleCategoryChange}
          />
        </div>
        <div>
          <label className="iss-lbl">
            Type <span style={{ color: accent }}>*</span>
          </label>
          <CustomSelect
            options={types}
            value={form.issueType}
            onChange={set("issueType")}
          />
        </div>
      </div>

      {/* Status */}
      <div className="iss-field">
        <label className="iss-lbl">
          Status <span style={{ color: accent }}>*</span>
        </label>
        <CustomSelect
          options={STATUSES}
          value={form.status}
          onChange={set("status")}
          withColor
        />
      </div>

      <div className="iss-divider" />

      {/* Description */}
      <div className="iss-field">
        <label className="iss-lbl">Description</label>
        <textarea
          className="iss-input"
          style={{ minHeight: 66, resize: "vertical" }}
          value={form.description}
          onChange={setE("description")}
          placeholder="Describe the issue…"
        />
      </div>

      {/* Assigned To */}
      <div className="iss-field">
        <label className="iss-lbl">Assigned To</label>
        <input
          className="iss-input"
          value={form.assignedTo}
          onChange={setE("assignedTo")}
          placeholder="Name, role or company"
        />
      </div>

      {/* Watchers */}
      <div className="iss-field">
        <label className="iss-lbl">Watchers</label>
        <input
          className="iss-input"
          value={form.watchers}
          onChange={setE("watchers")}
          placeholder="Members, roles, companies"
        />
      </div>

      {/* Location */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 11,
          marginBottom: 13,
        }}
      >
        <div>
          <label className="iss-lbl">Location</label>
          <input
            className="iss-input"
            value={form.location}
            onChange={setE("location")}
            placeholder="Floor 3, Zone B"
          />
        </div>
        <div>
          <label className="iss-lbl">Details</label>
          <input
            className="iss-input"
            value={form.locationDetails}
            onChange={setE("locationDetails")}
            placeholder="Additional info"
          />
        </div>
      </div>

      {/* Dates */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 11,
          marginBottom: 13,
        }}
      >
        <div>
          <label className="iss-lbl">Start Date</label>
          <input
            type="date"
            className="iss-input"
            style={{ colorScheme: "dark" }}
            value={form.startDate}
            onChange={setE("startDate")}
          />
        </div>
        <div>
          <label className="iss-lbl">Due Date</label>
          <input
            type="date"
            className="iss-input"
            style={{ colorScheme: "dark" }}
            value={form.dueDate}
            onChange={setE("dueDate")}
          />
        </div>
      </div>

      {/* Root Cause */}
      <div className="iss-field">
        <label className="iss-lbl">Root Cause</label>
        <CustomSelect
          options={ROOT_CAUSES}
          value={form.rootCause}
          onChange={set("rootCause")}
        />
      </div>

      {/* Actions */}
      <div style={{ display: "flex", gap: 9, marginTop: 20 }}>
        <button className="iss-btn-primary" onClick={handleSubmit}>
          Place Pin & Create
        </button>
        <button className="iss-btn-ghost" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
};

// ─── ContextMenu ──────────────────────────────────────────────────────────────
/**
 * Small dark context menu shown on right-click inside the Autodesk viewer.
 *
 * Props:
 *   visible  {boolean}
 *   x, y     {number}   – screen coords from the contextmenu event
 *   onSelect {(config) => void}  – called with ISSUE_TYPE_CONFIGS item
 *   onClose  {() => void}
 *   issueTypeConfigs {object}    – from extension (QUALITY, SAFETY, DESIGN, RFI)
 */
export const IssueContextMenu = ({
  visible,
  x,
  y,
  onSelect,
  onClose,
  issueTypeConfigs = {},
}) => {
  const ref = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!visible) return;
    const h = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [visible, onClose]);

  // Adjust position so menu doesn't overflow viewport
  const [pos, setPos] = useState({ top: y, left: x });
  useEffect(() => {
    if (!visible || !ref.current) return;
    const { offsetWidth: w, offsetHeight: h } = ref.current;
    setPos({
      top: Math.min(y, window.innerHeight - h - 10),
      left: Math.min(x, window.innerWidth - w - 10),
    });
  }, [visible, x, y]);

  const menuItems = [
    { key: "QUALITY", ...issueTypeConfigs.QUALITY, bg: "rgba(255,152,0,0.15)" },
    { key: "SAFETY", ...issueTypeConfigs.SAFETY, bg: "rgba(244,67,54,0.15)" },
    { key: "DESIGN", ...issueTypeConfigs.DESIGN, bg: "rgba(33,150,243,0.15)" },
    { key: "RFI", ...issueTypeConfigs.RFI, bg: "rgba(76,175,80,0.15)" },
  ];

  return (
    <div
      ref={ref}
      className={`iss-ctx-menu${visible ? " visible" : ""}`}
      style={{ top: pos.top, left: pos.left }}
    >
      <div className="iss-ctx-header">Create Issue</div>
      {menuItems.map((item) => (
        <div
          key={item.key}
          className="iss-ctx-item"
          onClick={() => {
            onSelect(item);
            onClose();
          }}
        >
          <div
            className="iss-ctx-item-icon"
            style={{ background: item.bg || "rgba(255,255,255,0.06)" }}
          >
            {item.icon || "📍"}
          </div>
          <span>{item.title || item.key}</span>
        </div>
      ))}
      <div className="iss-ctx-divider" />
      <div
        className="iss-ctx-item"
        style={{ color: "rgba(255,255,255,0.3)", fontSize: 12 }}
        onClick={onClose}
      >
        <div
          className="iss-ctx-item-icon"
          style={{ background: "rgba(255,255,255,0.04)" }}
        >
          ✕
        </div>
        Cancel
      </div>
    </div>
  );
};

// ─── IssueSidebar — main export ───────────────────────────────────────────────
/**
 * Props:
 *   isOpen          {boolean}
 *   onClose         {() => void}
 *   issueTypeConfig {object|null}  – icon, title, color, defaultLabel
 *   onSubmitForm    {(data) => void}
 */
const IssueSidebar = ({ isOpen, onClose, issueTypeConfig, onSubmitForm }) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const accent = issueTypeConfig?.color || "#2563eb";

  return (
    <>
      {/* Overlay */}
      <div
        className={`iss-overlay${isOpen ? " visible" : ""}`}
        onClick={onClose}
      />

      {/* Panel */}
      <div className={`iss-panel${isOpen ? " visible" : ""}`}>
        {/* Header */}
        <div
          style={{
            padding: "17px 20px 15px",
            borderBottom: "1px solid rgba(255,255,255,0.05)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexShrink: 0,
            background: "rgba(255,255,255,0.015)",
          }}
        >
          <div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 800,
                color: "#e4e8f4",
                letterSpacing: "-0.2px",
              }}
            >
              Create Issue
            </div>
            <div
              style={{
                fontSize: 11,
                color: "rgba(255,255,255,0.2)",
                marginTop: 2,
                fontFamily: "'DM Mono',monospace",
                letterSpacing: "0.3px",
              }}
            >
              BIM360 · Issue Tracker
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.07)",
              borderRadius: 7,
              color: "rgba(255,255,255,0.28)",
              width: 30,
              height: 30,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: 17,
              lineHeight: 1,
              flexShrink: 0,
              transition: "all 0.17s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "rgba(244,67,54,0.45)";
              e.currentTarget.style.color = "#f44336";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.07)";
              e.currentTarget.style.color = "rgba(255,255,255,0.28)";
            }}
          >
            ×
          </button>
        </div>

        {/* Form */}
        <div
          className="iss-scroll"
          style={{ flex: 1, overflowY: "auto", paddingTop: 17 }}
        >
          <CreateIssueForm
            issueTypeConfig={issueTypeConfig}
            onSubmit={(data) => {
              onSubmitForm?.(data);
            }}
            onClose={onClose}
          />
        </div>

        {/* Bottom accent */}
        <div
          style={{
            height: 3,
            background: `linear-gradient(90deg,${accent},transparent)`,
            flexShrink: 0,
            opacity: 0.75,
          }}
        />
      </div>
    </>
  );
};

export default IssueSidebar;
